/**
 * Iter59 — VisitasTab extraído de ClienteDetalle.jsx para reducir monolito.
 * Lectura + acciones; el padre proporciona handlers.
 */
import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Plus, MessageSquare, CheckSquare, Pencil, Trash2, ListChecks } from 'lucide-react';

export const VisitasTab = ({ visitas, onNueva, onEditar, onBorrar, onDerivarTarea }) => (
  <div data-testid="tab-visitas-content">
    <div className="flex items-center justify-between mb-4">
      <p className="text-sm text-ink-500">Reuniones realizadas con contactos de este cliente. Puedes derivar tareas de cada visita.</p>
      <Button className="bg-brand-500 hover:bg-brand-600 text-white" onClick={onNueva} data-testid="btn-nueva-visita">
        <Plus className="w-4 h-4 mr-1.5" /> Nueva visita
      </Button>
    </div>
    {visitas.length === 0 ? (
      <Card className="p-10 text-center text-ink-400 bg-white border-ink-200">
        Aún no hay visitas registradas.
      </Card>
    ) : (
      <div className="space-y-3">
        {visitas.map((v) => (
          <Card key={v.id} className="p-4 border-ink-200 bg-white" data-testid={`visita-${v.id}`}>
            <div className="flex items-start justify-between gap-3 mb-2">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-lg bg-brand-50 text-brand-600 flex items-center justify-center shrink-0">
                  <MessageSquare className="w-5 h-5" />
                </div>
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-ink-900 text-sm">{v.fecha}</span>
                    <Badge variant="outline" className="text-[10px] bg-white border-ink-200 text-ink-600">{v.tipo}</Badge>
                    {v.resultado && (
                      <Badge className={`text-[10px] border ${v.resultado === 'positivo' ? 'bg-emerald-50 border-emerald-200 text-emerald-700' : v.resultado === 'negativo' ? 'bg-red-50 border-red-200 text-red-700' : 'bg-ink-100 border-ink-200 text-ink-600'}`}>
                        {v.resultado}
                      </Badge>
                    )}
                  </div>
                  {v.contactos_nombres?.length > 0 && (
                    <p className="text-xs text-ink-500 mt-0.5">Con: {v.contactos_nombres.join(' · ')}</p>
                  )}
                </div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => onDerivarTarea(v)} className="p-1.5 rounded hover:bg-brand-50 text-brand-700" title="Generar tarea" data-testid={`btn-tarea-de-visita-${v.id}`}>
                  <CheckSquare className="w-4 h-4" />
                </button>
                <button onClick={() => onEditar(v)} className="p-1.5 rounded hover:bg-ink-100 text-ink-600" title="Editar"><Pencil className="w-4 h-4" /></button>
                <button onClick={() => onBorrar(v)} className="p-1.5 rounded hover:bg-red-50 text-red-600" title="Eliminar"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <p className="text-sm text-ink-700 whitespace-pre-wrap">{v.resumen}</p>
            {v.siguientes_pasos && (
              <div className="mt-2 p-2 bg-ink-50 border border-ink-100 rounded text-xs text-ink-700">
                <span className="font-semibold">Siguientes pasos: </span>{v.siguientes_pasos}
                {v.proxima_accion_fecha && <span className="text-amber-700 font-medium ml-2">· Próxima acción: {v.proxima_accion_fecha}</span>}
              </div>
            )}
            {v.num_tareas > 0 && (
              <p className="text-[11px] text-brand-700 mt-2 inline-flex items-center gap-1">
                <ListChecks className="w-3 h-3" /> {v.num_tareas} tarea{v.num_tareas > 1 ? 's' : ''} derivada{v.num_tareas > 1 ? 's' : ''}
              </p>
            )}
          </Card>
        ))}
      </div>
    )}
  </div>
);

export default VisitasTab;
